module.exports = __webpack_public_path__ + "static/img/quieromisdatos-1.690dacd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/quieromisdatos-1.jpg
// module id = 0VsF
// module chunks = 1